export const VESSEL_SPEC_STORE_ID = 'VesselSpecStore';
